import {YuJaTooltip} from "./standardization/YuJaTooltip";
import React, {cloneElement, useEffect, useId, useLayoutEffect, useRef, useState} from "react";
import useWindowDimensions from "../hooks/useWindowDimensions";

export default function OverflowText({placement="bottom", maxLines=1, children}) {
    let {width} = useWindowDimensions();
    let uniqueId = useId();
    const [text, setText] = useState("");
    const [isTitleTruncated, setIsTitleTruncated] = useState(false);
    const childRef = useRef();
    // Your requested hard-coded styles
    const truncationStyles = {
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        display: '-webkit-box',
        WebkitLineClamp: maxLines,
        WebkitBoxOrient: 'vertical',
        maxWidth: '100%',
        whiteSpace: 'normal',
        wordBreak: 'break-all'
    };


    const getTextFromChildren = (children) => {
        let text = '';

        React.Children.forEach(children, (child) => {
            if (typeof child === 'string' || typeof child === 'number') {
                text += child;
            } else if (child?.props?.children) {
                text += getTextFromChildren(child.props.children);
            }
        });

        return text;
    };


    useEffect(() => {
        let text = getTextFromChildren(children);
        setText(text);
    }, [children]);

    useLayoutEffect(() => {
        checkIfTitleTruncated();
    }, [width, children]);


    const checkIfTitleTruncated = () => {
        let titleEle = document.getElementById(uniqueId);
        if (!titleEle) {
            return;
        }


        setIsTitleTruncated(titleEle.scrollHeight > titleEle.clientHeight);
    }



    return (

        <YuJaTooltip
            text={text}
            placement={placement}
            disabled={!isTitleTruncated}
            disableTab={true}
        >
            {cloneElement(children, {
                id: uniqueId,
                ref: childRef,
                style: { ...children.props.style, ...truncationStyles },
            })}
        </YuJaTooltip>
    );
}